exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2.answer_open_title[data-v-2a7b496c]{padding-left:56px!important;text-indent:-56px!important}span.label_text[data-v-2a7b496c]{background-color:#f4f6f8!important}div.form-row.is_error>div>label>span.label_text[data-v-2a7b496c]{font-weight:700!important;border-color:#dc3545!important}div.form-row.is_error>div>input.form-control[data-v-2a7b496c]{font-weight:700!important;color:#721c24!important;border-color:#dc3545!important;background-color:#f8d7da!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a7b496c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/question/AnswerOpen.vue
// module id = 114
// module chunks = 0